import { t } from 'i18next';
import * as yup from 'yup';
import { ObjectSchema, StringSchema } from 'yup';

import { IAuthUser } from 'auth/types';
import { testRequiredSchema } from 'core/schemas';
import { OrderType } from 'quotes/enums';

import { shipSelectionSchema } from '../CustomerQuoteUpsert/ShipSelectionDateFields/schema';

const externalUserIdSchema = (isAlternateVersionEnabled: boolean, isCompanyAdmin: boolean) => {
  const fieldSchema = yup.string().label(t('labelExternalUserId')).nullable();

  if (isAlternateVersionEnabled && !isCompanyAdmin) {
    return { externalUserId: fieldSchema };
  }

  return { externalUserId: fieldSchema.required() };
};

export const submitCustomerOrderSchema = (user: IAuthUser, isAlternateVersionEnabled = false) => {
  const ddpOrderIntegrationEnabled = user.companySettings.ddpOrderIntegrationEnabled ?? false;

  const extraFields: {
    orderType?: StringSchema;
    shippingMethod?: ObjectSchema<{
      id: StringSchema;
      name: StringSchema;
    }>;
    freightTerm?: ObjectSchema<{
      id: StringSchema;
      name: StringSchema;
    }>;
  } = {};

  if (isAlternateVersionEnabled) {
    extraFields.orderType = yup
      .string()
      .label(t('labelOrderType'))
      .nullable()
      .oneOf(Object.values(OrderType))
      .test(...testRequiredSchema(ddpOrderIntegrationEnabled, t('labelOrderType')));

    extraFields.shippingMethod = yup
      .object()
      .shape({
        id: yup.string().label(t('labelShippingMethod')).nullable(),
        name: yup.string().label(t('labelShippingMethod')).nullable(),
      })
      .nullable()
      .test(...testRequiredSchema(ddpOrderIntegrationEnabled, t('labelShippingMethod')));

    extraFields.freightTerm = yup
      .object()
      .shape({
        id: yup.string().label(t('labelFreightTerm')).nullable(),
        name: yup.string().label(t('labelFreightTerm')).nullable(),
      })
      .nullable()
      .test(...testRequiredSchema(ddpOrderIntegrationEnabled, t('labelFreightTerm')));
  }

  return yup.object().shape({
    ...externalUserIdSchema(isAlternateVersionEnabled, user.companyAdmin),
    location: yup.object().label(t('labelOrderLocation')).nullable().required(),
    ...extraFields,
    ...(isAlternateVersionEnabled ? shipSelectionSchema(ddpOrderIntegrationEnabled) : {}),
  });
};
